<!-- Error Views -->
<app-module-error class="flex-fill" *ngIf="noData" [noData]="true"></app-module-error>
<!-- Content -->
<div class="gridItemChildModule w-100 h-100 d-flex flex-column" *ngIf="dataLoadSuccess && !noData">
    <!-- Place main body content here -->
    <!-- Search -->
    <div *ngIf="!isCXOne" class="w-75 mx-auto my-2 search-box live-search" [hidden]="!showFilter">
        <input type="search" class="form-control"
            autocomplete="off"
            [(ngModel)]="filterValue"
            (ngModelChangeDebounced)="applyFilter()"
            [ngModelChangeDebounceTime]="500"
            placeholder="Search..."
            cvLocalizedPlaceholder
            [langSection]="'Common'"
            [langKey]="'Search'"
        />
        <span class="clear-input" role="button" tabindex="0"
            [hidden]="filterValue.length === 0"
            (click)="clearFilter()">
        </span>
    </div>

    <!-- Search cxone -->
    <div *ngIf="isCXOne" class="cxone-live-search ml-2 my-2" [hidden]="!showFilter">
        <cxone-text-input [(ngModel)]="filterValue" [placeholder]="searchPlaceholder" (keyup)="applyFilter()" class="cxone-widget-search" name="cxoneInput-{{moduleKey}}"
            (ngModelChangeDebounced)="filterValue" [ngModelChangeDebounceTime]="500"></cxone-text-input>
        <i class="cxone-search-icon" [hidden]="filterValue.length !== 0">
            <svg class="icon-18 fill-iconDefault-noHover cxone-search-wrapper">
                <use href="../App_Themes/CXone/icons/search.svg#search"></use>
            </svg>
        </i>
        <i [hidden]="filterValue.length === 0" (click)="clearFilter()">
            <svg class="icon-18 fill-iconDefault-noHover cxone-close-wrapper">
                <use href="../App_Themes/CXone/icons/close.svg#close"></use>
            </svg>
        </i>
    </div>

    <sol-inline-notification *ngIf="isLimitNotificationShown"
        style="margin-top: -12px !important;"
        class="ml-2 mr-2"
        type="info"
        [message]="limitNotificationMessage"
        [show]="isLimitNotificationShown"
        (close)="closeLimitNotification()">
    </sol-inline-notification>

    <!-- Ag Grid table component -->
    <div class="flex-fill" style="overflow-y: auto;">
        <ag-grid-angular #reportWidgetGrid *ngIf="gridOptions !== null"
            class="ag-theme-balham flex-fill"
            [gridOptions]="gridOptions"
            style="height:100%; width:100%;">
        </ag-grid-angular>
    </div>
</div>
